import React from "react";
import { useEffect,useContext,useState } from "react";
import { GlobalContext } from '../../GlobalContext';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";


const Body = ({userprofile,showbutton = true}) => {
    const { t, i18n } = useTranslation()  
     const [usersdetail, setUserdeatisl] = useState(true);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { siteName } = useContext(GlobalContext);
     const { setLogin } = useContext(GlobalContext);
        const logout_action = () => {
          localStorage.removeItem('token');
          localStorage.removeItem('name');
          localStorage.removeItem('loginbefore');
          localStorage.removeItem('role');
          setLogin(false);
          window.location.reload();
        };
      let baseUrl = siteName.baseUrl;
        let defult_endpoint = siteName.webEndpoints;
          useEffect(() => {
        
      
            const fetchSession_dat = async () => {
              const token = localStorage.getItem('token');

              try {
                const response = await fetch(baseUrl + defult_endpoint + 'get/user/details', {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              }
            });
                if (!response.ok) {
                  logout_action();
                  throw new Error('Network response was not ok');
                }
                const allession_data = await response.json();
                console.log(allession_data)
                setUserdeatisl(allession_data);
              } catch (error) {
                logout_action();
                setError(error);
                setLoading(false);
              }
            };
          
            fetchSession_dat();
          }, []);
      
          if (loading) console.log(loading);
          if (error) console.log(error);
  return (
    <section>
          <section className="page-title-section">
        <div className="container">
            <div className="page-content-wrapper d-flex align-items-center justify-content-between">
            <div className="page-content-left">
                <h1>{t("Welcome_Back")} <span>{usersdetail.fullName}</span></h1>
                <p>{userprofile.description}</p>
            </div>
             <div className="page-title-logo">
                <img src={userprofile.logo} alt="Page Banner Title"/>
                  {showbutton? <div className="page-title-logo profile-buttons">
               <Link to="/createtrainter"><button className="cfn-global-btn">{t('Add_Training_Session')}</button></Link>
               <Link to="/changepassword"><button className="cfn-global-btn">{t('reset_password')}</button></Link>
            </div> : ''}
            </div>
          
            </div>
        </div>
    </section>
    </section>
  );
};

export default Body;